import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0c335046"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex align-center mb-12 pb-6 gap-12 border-b border-b-[#EAECF0] w-full" }
const _hoisted_2 = ["onClick"]

import { ref } from "vue";

// Array of button names

export default /*#__PURE__*/_defineComponent({
  __name: 'InternalViewNav',
  setup(__props) {

const buttons = ['Create', 'Add', 'Edit', 'Track', 'Push'];

// Track which button is active
const activeButton = ref(2);

// Function to set active button
const setActiveButton = (index: any) => {
  activeButton.value = index;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(buttons, (button, index) => {
      return _createElementVNode("button", {
        key: index,
        class: _normalizeClass(["px-4 py-2 nav-buttons rounded-lg", { active: activeButton.value === index }]),
        onClick: ($event: any) => (setActiveButton(index))
      }, _toDisplayString(button), 11, _hoisted_2)
    }), 64))
  ]))
}
}

})